var requireNonNull = require('util/require-non-null');

function FilterSendResult(sent, errors) {
    this.sent = requireNonNull(sent);
    this.errors = requireNonNull(errors);
}

FilterSendResult.prototype.toString = function() {
    return 'FilterSendResult [' + this.sent + ' sent, errors=' + this.errors + ']';
};

module.exports = FilterSendResult;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/send/filter-send-result.js
// module id = 336
// module chunks = 1